import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-2 text-sm text-foreground-500">深度策划，发现更多好内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <article key={item.id} className="group cursor-pointer">
              <div className="relative rounded-lg overflow-hidden aspect-[16/10] bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentNode as HTMLElement)?.classList.add('bg-background-200');
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-sm md:text-base font-semibold text-white leading-snug">{item.title}</h3>
                  <p className="mt-1 text-xs text-white/70 line-clamp-1">{item.subtitle}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}